import { DatePicker } from "../DatePicker";

export function PolicyEffectiveDate({
  control,
  openPolicyDate,
  setOpenPolicyDate,
}) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const maxDate = new Date(today);
  maxDate.setDate(today.getDate() + 30);

  return (
    <div className="space-y-2">
      <DatePicker
        control={control}
        open={openPolicyDate}
        setOpen={setOpenPolicyDate}
        label="Policy Effective Date"
        disabled={(date) => {
          if (date < today) return true;
          if (date > maxDate) return true;
          return false;
        }}
        startMonth={today}
        endMonth={maxDate}
        name="step1.policyDate"
        step="step1"
        showTodayButton={true}
        quickToday={true}
      />
    </div>
  );
}
